export default __webpack_public_path__ + "static/tops-d021ea060ee72221b3e88b0ae4a322a0.png";